export default [

    {
        path: '/measurements/list',
        name: 'measurements-measurement-list',
        component: () => import('@/views/apps/measurement/measurement/views/List.vue'),
        meta: {
            resource: 'measurement',
            action: 'read',
            pageTitle: 'Замеры',
            breadcrumb: [
                {
                  text: 'Список замеров',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/measurements/view/:id',
        name: 'measurements-measurement-view',
        component: () => import('@/views/apps/measurement/measurement/views/Details.vue'),
        meta: {
            resource: 'measurement',
            action: 'read',
            pageTitle: 'Замеры',
            breadcrumb: [
                {
                  text: 'Список замеров',
                  to: { name: 'measurements-measurement-list' }
                },
                {
                  text: 'Детальная информация',
                    active: true
                },
            ],
        },
    },
]
